export const UPDATE_USER = 'UPDATE_USER'
export const UPDATE_GLOBAL_DATA = 'UPDATE_GLOBAL_DATA'



// WEBPACK FOOTER //
// ./src/store/mutation-types.js